export default class ComposerEvent {
    constructor(type) {
        this.type = type;
    }
}

ComposerEvent.OPEN_SCREEN_REQUEST = "ComposerEvent.OPEN_SCREEN_REQUEST";
ComposerEvent.CLOSE_SCREEN_REQUEST = "ComposerEvent.CLOSE_SCREEN_REQUEST";
ComposerEvent.GOTO_SCREEN_REQUEST = "ComposerEvent.GOTO_SCREEN_REQUEST";
ComposerEvent.TAB_READY_TO_SUBMIT = "ComposerEvent.TAB_READY_TO_SUBMIT";
ComposerEvent.TAB_NOT_READY_TO_SUBMIT = "ComposerEvent.TAB_NOT_READY_TO_SUBMIT";